'use client';

import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';
import styles from './marketo-thank-you.module.scss';

export type MarketoThankYouProps = {
  onGoBack?: () => void;
  className?: string;
  formContent?: {
    formId: number;
    slugId: string;
    badge?: string;
    title?: string;
    description?: string;
    successTitle?: string;
    successDescription?: string;
    successCTA?: {
      label?: string;
      url?: string;
      type?: 'Button' | 'Link';
    };
  };
};

export const MarketoThankYou = ({ onGoBack, className, formContent }: MarketoThankYouProps) => {
  return (
    <div className={cn(styles['thank-you'], className)}>
      <div className={styles['thank-you__illustration']}>
        <svg
          width="240"
          height="182"
          viewBox="0 0 240 182"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_58571_32854"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="240"
            height="182"
          >
            <path d="M240 0H0V181.371H240V0Z" fill="white" />
          </mask>
          <g mask="url(#mask0_58571_32854)">
            <mask
              id="mask1_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask1_58571_32854)">
              <g style={{ mixBlendMode: 'multiply' }} opacity="0.8">
                <mask
                  id="mask2_58571_32854"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="-16"
                  y="-18"
                  width="271"
                  height="209"
                >
                  <path d="M254.67 -17.7969H-15.6211V190.161H254.67V-17.7969Z" fill="white" />
                </mask>
                <g mask="url(#mask2_58571_32854)">
                  <path
                    d="M121.307 11.7418C86.7309 19.68 90.1434 52.9794 54.8576 57.0412C15.9838 61.5165 -0.662251 89.0251 13.0716 116.719C26.8055 144.41 79.9494 128.654 100.482 157.165C132.014 200.952 197.432 178.696 199.94 142.789C203.549 91.1991 233.494 107.071 230.856 64.4937C228.843 32.0504 172.688 -0.0562286 121.307 11.7418Z"
                    fill="#EEF1F3"
                  />
                </g>
              </g>
              <g opacity="0.15">
                <mask
                  id="mask3_58571_32854"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="-18"
                  y="67"
                  width="146"
                  height="90"
                >
                  <path d="M127.359 67.3203H-17.5V156.118H127.359V67.3203Z" fill="white" />
                </mask>
                <g mask="url(#mask3_58571_32854)">
                  <path d="M108.763 83.8438H1.08984V154.047H108.763V83.8438Z" fill="white" />
                </g>
              </g>
              <path
                d="M1.51022 150.8V84.5187H108.399V150.8C108.399 152.233 107.233 153.402 105.797 153.402H4.11222C2.67896 153.402 1.51022 152.236 1.51022 150.8ZM109.909 150.8V79.8798C109.909 77.6145 108.065 75.7676 105.797 75.7676H4.11222C1.84449 75.7676 0 77.6121 0 79.8798V150.8C0 153.065 1.84208 154.912 4.11222 154.912H105.797C108.063 154.912 109.909 153.068 109.909 150.8Z"
                fill="#BCBEC0"
              />
              <path
                d="M7.37982 80.184C7.37982 81.0185 6.70406 81.6943 5.8696 81.6943C5.03513 81.6943 4.35938 81.0185 4.35938 80.184C4.35938 79.3496 5.03513 78.6738 5.8696 78.6738C6.70406 78.6738 7.37982 79.3496 7.37982 80.184Z"
                fill="#280071"
              />
              <path
                d="M10.4008 78.6738C9.56638 78.6738 8.89062 79.3496 8.89062 80.184C8.89062 81.0185 9.56638 81.6943 10.4008 81.6943C11.2353 81.6943 11.9111 81.0185 11.9111 80.184C11.9111 79.3496 11.2353 78.6738 10.4008 78.6738Z"
                fill="#53338D"
              />
              <path
                d="M14.936 78.6738C14.1039 78.6738 13.4258 79.3496 13.4258 80.184C13.4258 81.0185 14.1039 81.6943 14.936 81.6943C15.7681 81.6943 16.4462 81.0185 16.4462 80.184C16.4462 79.3496 15.7705 78.6738 14.936 78.6738Z"
                fill="#7E66AA"
              />
              <path
                d="M42.7965 87.5057C42.7965 87.5057 35.7359 91.1177 40.8822 98.8732C40.8822 98.8732 34.8149 99.573 33.2878 97.8295C33.2878 97.8295 33.5187 98.5919 33.788 98.9646C33.788 98.9646 27.9107 98.1951 25.8041 95.9682C23.6999 93.7414 30.2674 64.1093 45.9203 70.1766C45.9203 70.1766 59.8369 71.444 55.8882 87.133C51.9371 102.82 57.1267 103.69 57.1267 103.69C57.1267 103.69 55.566 104.159 54.8662 104.044C54.8662 104.044 53.9139 103.483 53.8081 102.887C53.8081 102.887 53.8586 103.803 54.075 104.13C54.075 104.13 48.3828 103.719 45.942 101.136C43.5011 98.551 41.4498 90.6536 42.7989 87.5081"
                fill="#EEC480"
              />
              <path
                d="M52.8758 95.2614L52.3107 95.3408C49.7953 95.6895 47.4506 93.9147 47.0995 91.3993L46.6883 88.4438C46.3396 85.9284 48.1143 83.5813 50.6298 83.2326L51.1949 83.1556C53.7103 82.8045 56.0574 84.5793 56.4061 87.0971L56.8149 90.0502C57.1636 92.5681 55.3913 94.9128 52.8734 95.2614"
                fill="#280071"
              />
              <path
                d="M54.4928 118.946C52.3862 120.572 51.054 126.444 47.656 127.411C34.9225 131.047 28.0856 115.926 25.8516 108.543C27.559 107.449 29.2015 107.143 30.149 106.98C31.0748 106.824 32.0512 106.699 32.8592 106.619C34.2492 105.436 36.1754 100.792 36.2932 93.7246L36.9065 93.8545L47.2039 96.1174C47.2039 96.1174 46.9033 99.3687 46.8311 102.432C46.7758 104.83 46.6989 105.402 46.8816 105.689C47.6824 105.818 48.6275 107.867 48.6275 107.867C48.6275 107.867 48.6275 107.867 48.6323 107.875C48.7814 108.091 51.975 112.788 54.4928 118.946Z"
                fill="#D9945C"
              />
              <path
                d="M47.1982 96.1179C47.1982 96.1179 46.8976 99.3668 46.8255 102.433C41.0419 102.149 38.0912 96.8081 36.8984 93.8574L47.1958 96.1179H47.1982Z"
                fill="#CC7D45"
              />
              <path
                d="M99.572 149.526C99.572 149.526 93.5167 149.75 86.9419 149.771C86.1628 149.776 85.3764 149.776 84.59 149.771C79.2345 149.75 73.9704 149.56 71.7315 148.983C69.5431 148.418 61.1263 142.716 54.3928 135.804V135.8C53.871 137.045 53.4766 137.995 53.4646 138.072C53.2674 139.623 52.9379 141.177 52.5363 142.67C51.0093 148.365 48.465 153.143 48.3784 153.309L44.7712 153.302L16.6133 153.261C16.6133 153.261 21.9327 145.068 20.5043 124.081C20.4682 123.549 25.4077 106.617 25.4077 106.617C25.4077 106.617 29.2457 105.946 33.6802 105.588C34.0987 105.968 34.962 117.109 40.5075 117.754C41.4093 117.857 47.1977 126.7 47.1977 126.7L48.9484 117.667L46.8754 105.684C49.5375 106.463 50.9973 106.745 53.2097 107.627C54.7151 108.231 55.9632 109.339 56.7399 110.763C60.6165 117.845 73.1936 140.689 74.4778 141.222C75.6802 141.72 80.2109 142.627 85.0061 143.502H85.0109C91.4245 144.673 98.3119 145.784 98.3119 145.784L99.5768 149.519L99.572 149.526Z"
                fill="#F0A3CE"
              />
              <path
                d="M48.9113 99.2106C48.9113 99.2106 35.2183 98.9413 35.5165 90.4187C35.8171 81.8936 34.2492 76.1173 43.0051 75.9297C51.761 75.7397 53.3434 79.0535 53.935 81.9225C54.5289 84.7914 52.48 99.0639 48.9113 99.2106Z"
                fill="#D9945C"
              />
              <path
                d="M86.9436 149.769C86.1669 149.774 85.3781 149.774 84.5941 149.769C79.2386 149.748 73.9745 149.558 71.7356 148.983C69.5472 148.418 61.1304 142.716 54.3945 135.804V135.8C54.3945 135.8 55.8158 130.36 56.4266 129.449C57.0398 128.535 59.4543 137.384 65.1007 140.987C70.7472 144.587 79.5825 147.11 83.8703 146.09C86.7609 145.402 87.0567 147.999 86.9412 149.769"
                fill="#E974B5"
              />
              <path
                d="M46.966 97.9195C39.1865 95.4618 37.2771 88.0958 37.2578 88.0213L38.0875 87.8169L37.6714 87.9179L38.0875 87.8145C38.1043 87.8842 39.9127 94.7932 47.2233 97.1018C47.2738 97.1187 47.3195 97.1331 47.37 97.1499L47.1223 97.9652C47.0694 97.9507 47.0165 97.9339 46.966 97.9171"
                fill="#263338"
              />
              <path
                d="M47.8477 98.4935L47.1142 98.2627C46.7414 98.1449 46.5322 97.7432 46.6501 97.3681C46.7679 96.9953 47.1695 96.7861 47.5446 96.904L48.2781 97.1348C48.6509 97.2527 48.8601 97.6543 48.7422 98.0294C48.6244 98.4022 48.2228 98.6114 47.8477 98.4935Z"
                fill="#263338"
              />
              <path
                d="M49.6956 74.8012C49.6956 74.8012 46.1894 85.1852 40.9301 86.9455C35.6732 88.7083 33.9297 86.6233 33.9297 86.6233C33.9297 86.6233 37.8062 83.0642 38.2487 77.3046C38.2487 77.3046 46.7449 70.5543 49.6956 74.8012Z"
                fill="#EEC480"
              />
              <path
                d="M43.1469 77.8562C43.1469 77.8562 50.2868 77.4546 52.4199 79.489C53.9566 80.956 53.9229 81.7207 54.0407 83.6734C54.0407 83.6734 57.1622 78.859 53.9493 75.4874C50.5417 71.9139 43.1445 77.8562 43.1445 77.8562"
                fill="#EEC480"
              />
              <path
                d="M49.3895 75.8989C49.3895 75.8989 47.6027 85.8332 41.0664 89.4452C41.0664 89.4452 47.3959 82.9642 47.5089 76.4809C47.6219 69.9999 49.3919 75.8989 49.3919 75.8989"
                fill="#EEC480"
              />
              <path
                d="M25.8041 95.9671C27.9083 98.1939 33.7856 98.9659 33.7856 98.9659C33.5163 98.5931 33.2879 97.8308 33.2879 97.8308C36.3107 100.279 43.7271 98.4993 43.7271 98.4993C37.8113 97.1935 39.7279 88.654 41.7408 88.2909C42.9119 81.8484 45.2374 73.8308 46.3291 70.2308C46.067 70.1875 45.9179 70.1755 45.9179 70.1755C30.2674 64.113 23.6999 93.7426 25.8041 95.9671Z"
                fill="#EEC480"
              />
              <path
                d="M38.661 94.3824L38.0959 94.4618C35.5804 94.8105 33.2358 93.0357 32.8847 90.5203L32.4734 87.5648C32.1247 85.0494 33.8995 82.7023 36.4149 82.3536L36.98 82.2742C39.4955 81.9255 41.8426 83.7003 42.1913 86.2181L42.6001 89.1712C42.9488 91.689 41.1764 94.0337 38.6586 94.3824"
                fill="#280071"
              />
              <path
                d="M34.9559 83.6016C34.6193 82.9715 35.7976 78.0777 37.5315 74.2805C38.3684 72.4457 40.4822 69.9904 41.9924 69.3579C42.5383 69.1294 43.2597 69.2208 43.8513 69.3579C44.2818 69.4541 45.4842 70.0144 45.4842 70.0144C40.5255 71.5607 36.2161 81.9519 36.5287 83.0292C36.5191 82.9956 36.507 82.9715 36.495 82.9523L34.9559 83.604V83.6016Z"
                fill="#280071"
              />
              <path
                d="M37.5187 91.2004L37.2374 91.2389C35.9845 91.412 34.8133 90.5271 34.6402 89.2741L34.4358 87.8024C34.2626 86.5471 35.1452 85.3784 36.4005 85.2052L36.6818 85.1667C37.9348 84.9912 39.1059 85.8762 39.279 87.1291L39.4834 88.6032C39.6566 89.8561 38.7716 91.0273 37.5187 91.2004Z"
                fill="#53338D"
              />
              <path
                d="M70.7485 144.587C70.7485 144.587 76.6186 144.25 77.191 144.556C78.1168 145.056 81.2719 147.086 81.7649 147.677C82.2603 148.269 83.5541 150.635 83.5541 150.635C83.5541 150.635 82.9938 150.789 82.7413 150.563C82.4888 150.337 80.5745 148.3 80.5745 148.3L82.5417 151.289C82.5417 151.289 81.8611 151.26 81.5918 150.962C81.3224 150.664 79.4828 148.795 79.4828 148.795L78.8575 148.67C78.8575 148.67 79.4948 149.183 79.8411 149.644C80.1874 150.106 80.4182 150.604 80.4182 150.604C80.4182 150.604 79.8579 150.508 79.6824 150.426C79.5068 150.342 77.8571 148.899 77.8571 148.899L78.7301 150.092C78.7301 150.092 78.1409 150.063 77.9461 149.933C77.7537 149.801 76.4695 148.618 76.2411 148.62C76.0126 148.62 74.3725 148.555 73.6679 148.18C72.9633 147.807 70.7533 146.953 70.7533 146.953L70.7461 144.582L70.7485 144.587Z"
                fill="#D9945C"
              />
              <path
                d="M34.4857 103.959C34.4857 103.959 30.5587 105.104 29.6641 106.005C29.6641 106.005 33.7691 116.498 39.6873 121.399L41.2697 120.276V122.827L47.1951 126.704C47.1951 126.704 34.1827 107.133 34.4857 103.959Z"
                fill="#E974B5"
              />
              <path
                d="M52.5373 142.669C51.0103 148.364 48.466 153.142 48.3794 153.308H50.3898L48.3746 153.315H29.6676C29.6676 153.315 31.8367 153.31 31.8319 153.301C31.7814 153.111 34.9966 144.396 29.6676 140.825C24.3265 137.246 22.3906 128.45 22.3906 128.45L39.3806 124.299C39.3806 124.299 46.3786 134.512 48.3722 136.46C49.9016 137.956 53.4656 138.066 53.4656 138.066L52.5373 142.664V142.669Z"
                fill="#E974B5"
              />
              <path
                d="M46.8774 105.69C46.8774 105.69 48.6859 119.97 47.1973 126.704C47.1973 126.704 49.6237 122.248 49.9628 121.432L49.554 118.982L51.1195 119.528C51.1195 119.528 49.7392 108.143 48.4887 106.147C47.2406 104.151 46.7812 103.959 46.7812 103.959L46.8774 105.69Z"
                fill="#E974B5"
              />
              <path
                d="M99.5746 149.525C99.5746 149.525 91.9995 149.804 84.5927 149.77C82.7554 146.921 85.0063 143.506 85.0063 143.506H85.0111C91.4247 144.677 98.3121 145.788 98.3121 145.788L99.577 149.523L99.5746 149.525Z"
                fill="#D9945C"
              />
              <path
                d="M100.296 153.316H72.2969C72.2969 152.082 73.2973 151.084 74.5285 151.084H100.296V153.316Z"
                fill="#1C3047"
              />
            </g>
            <path
              d="M143.502 122.824L133.214 153.036L133.118 153.317H90.1875L100.85 122.824H143.502Z"
              fill="#1C3047"
            />
            <mask
              id="mask4_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask4_58571_32854)">
              <path
                d="M120.806 137.791C120.536 138.957 119.375 139.9 118.208 139.9C117.042 139.9 116.318 138.955 116.587 137.791C116.857 136.624 118.018 135.682 119.185 135.682C120.351 135.682 121.075 136.627 120.806 137.791Z"
                fill="#280071"
              />
            </g>
            <path
              d="M143.503 122.824L133.215 153.036H113.488L137.541 122.824H143.503Z"
              fill="#152435"
            />
            <mask
              id="mask5_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask5_58571_32854)">
              <path
                d="M70.7542 146.961C70.7542 146.961 56.3397 148.221 48.375 147.865V140.037C53.5934 141.478 70.7493 144.589 70.7493 144.589L70.7566 146.961H70.7542Z"
                fill="#D9945C"
              />
              <path
                d="M29.6681 106.004C29.6681 106.004 21.4244 106.191 18.8729 108.947C16.3214 111.701 21.4028 127.274 21.4028 127.274C21.4028 127.274 36.7695 146.092 44.4529 147.42C44.4529 147.42 47.8124 147.879 49.3803 147.903C49.3803 147.903 47.8437 143.428 50.703 140.619C50.703 140.619 47.4132 139.698 47.2761 139.291C47.1391 138.882 29.6657 106.006 29.6657 106.006"
                fill="#F0A3CE"
              />
              <g opacity="0.15">
                <mask
                  id="mask6_58571_32854"
                  style={{ maskType: 'luminance' }}
                  maskUnits="userSpaceOnUse"
                  x="120"
                  y="15"
                  width="139"
                  height="88"
                >
                  <path d="M258.591 15.9199H120.117V102.681H258.591V15.9199Z" fill="white" />
                </mask>
                <g mask="url(#mask6_58571_32854)">
                  <path d="M240.003 32.4473H138.715V100.616H240.003V32.4473Z" fill="white" />
                </g>
              </g>
              <path
                d="M138.353 96.7682V34.7049H238.441V96.7682C238.441 98.1101 237.349 99.2043 236.005 99.2043H140.789C139.447 99.2043 138.353 98.1125 138.353 96.7682ZM239.853 96.7682V30.3594C239.853 28.236 238.126 26.5117 236.005 26.5117H140.789C138.668 26.5117 136.941 28.236 136.941 30.3594V96.7658C136.941 98.8869 138.668 100.614 140.789 100.614H236.005C238.126 100.614 239.853 98.8869 239.853 96.7658"
                fill="#BCBEC0"
              />
              <path
                d="M143.85 30.6445C143.85 31.4261 143.217 32.0585 142.436 32.0585C141.654 32.0585 141.021 31.4237 141.021 30.6445C141.021 29.8653 141.654 29.2305 142.436 29.2305C143.217 29.2305 143.85 29.8629 143.85 30.6445Z"
                fill="#280071"
              />
              <path
                d="M146.68 29.2305C145.898 29.2305 145.266 29.8629 145.266 30.6445C145.266 31.4261 145.898 32.0585 146.68 32.0585C147.461 32.0585 148.094 31.4237 148.094 30.6445C148.094 29.8653 147.459 29.2305 146.68 29.2305Z"
                fill="#53338D"
              />
              <path
                d="M150.92 29.2305C150.138 29.2305 149.506 29.8629 149.506 30.6445C149.506 31.4261 150.138 32.0585 150.92 32.0585C151.701 32.0585 152.334 31.4237 152.334 30.6445C152.334 29.8653 151.699 29.2305 150.92 29.2305Z"
                fill="#7E66AA"
              />
            </g>
            <path d="M199.129 36.9277H186.66V52.7177H199.129V36.9277Z" fill="#C44A00" />
            <path
              d="M199.492 40.674L197.07 43.3674L190.916 35.8788L199.213 34.6211L199.492 40.674Z"
              fill="#C44A00"
            />
            <mask
              id="mask7_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="137"
              y="-1"
              width="96"
              height="101"
            >
              <path d="M232.107 -0.00195312H137.834V99.2373H232.107V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask7_58571_32854)">
              <path
                d="M183.627 51.0347L190.551 48.916H196.866L205.287 51.6695L192.172 61.385C192.172 61.385 179.296 59.793 183.63 51.0347"
                fill="#C44A00"
              />
              <path
                d="M195.722 19.2514C195.722 19.2514 185.331 15.7548 180.199 28.3271C180.199 28.3271 179.444 30.3303 180.171 32.0113L180.375 32.3913L178.482 35.9456C178.482 35.9456 178.367 36.8233 179.165 37.0349C179.966 37.2466 180.223 37.2201 180.223 37.2201L179.091 38.9468L179.543 40.0289C179.543 40.0289 179.067 41.087 179.656 41.4911C180.245 41.8951 180.676 42.4891 180.676 42.4891L180.62 44.2854C180.62 44.2854 180.906 45.7283 182.061 46.0217C183.215 46.3127 186.526 45.6177 186.526 45.6177C186.526 45.6177 192.238 44.7568 193.301 43.2081C194.364 41.6618 194.405 40.0674 194.405 40.0674L193.955 36.7488L200.919 38.2662C200.919 38.2662 204.185 34.4233 203.952 30.2293C203.718 26.0354 201.797 21.1392 195.722 19.2442"
                fill="#C44A00"
              />
              <path
                d="M196.883 31.1656C199.716 31.3243 199.497 33.9864 198.766 35.4004C198.348 36.2133 198.083 36.8024 197.941 37.6177L193.959 36.7495C193.555 34.3784 194.05 31.0068 196.883 31.1656Z"
                fill="#C44A00"
              />
              <path
                d="M191.106 29.057C191.106 29.057 190.278 27.8233 187.559 27.9147L188.951 23.5331L200.285 21.7969C202.841 24.1392 203.68 27.3616 203.957 30.2354C204.445 35.2855 199.494 40.6746 199.494 40.6746L197.947 37.6205C198.087 36.8077 198.351 36.2161 198.772 35.4033C199.501 33.9893 199.717 31.3247 196.889 31.166C194.056 31.0097 193.094 35.9588 193.085 35.9804L190.673 35.4514C190.673 35.4514 193.746 32.4382 191.106 29.0546"
                fill="#992E00"
              />
              <path
                d="M182.265 24.4456C187.695 16.553 195.727 19.2488 195.727 19.2488C198.161 20.0087 199.916 21.252 201.176 22.7357L182.217 24.662C182.229 24.585 182.253 24.5177 182.267 24.4431"
                fill="#263338"
              />
              <path
                d="M200.065 21.6836C200.065 21.6836 205.716 23.2948 203.946 18.5694C202.178 13.8415 195.628 15.9914 197.275 20.3514L200.065 21.6836Z"
                fill="#263338"
              />
              <path
                d="M202.936 50.8169L215.599 54.6213C219.31 55.891 222.465 58.8417 224.283 62.3167C225.115 63.9062 225.788 65.8301 226.108 68.1291C227.376 77.3275 230.548 92.5475 230.548 92.5475L216.277 102.378L211.521 80.497L202.957 65.907L202.936 50.8145V50.8169Z"
                fill="#F8D1E6"
              />
              <path
                d="M183.621 51.0254L171.652 54.623C167.941 55.8903 164.786 58.8434 162.968 62.3184C162.136 63.908 161.737 65.8871 161.145 68.1308C158.7 77.4158 154.652 99.9272 154.652 99.9272L170.974 102.383L175.73 80.5011L184.294 65.9136L183.621 51.0278V51.0254Z"
                fill="#F8D1E6"
              />
              <path
                d="M183.627 51.0285C183.627 51.0285 187.068 55.3066 193.14 55.3066C199.619 55.3066 203.019 50.8145 203.019 50.8145L210.63 83.0389L178.933 81.2161L178.002 63.6056L183.629 51.0285H183.627Z"
                fill="#F8D1E6"
              />
            </g>
            <path
              d="M162.406 73.6595L169.897 81.7902L170.044 99.2371H221.206L223.984 72.5918L162.406 73.6595Z"
              fill="#F8D1E6"
            />
            <path
              d="M212.492 77.8612L217.838 99.24H232.106V93.7955L225.772 66.5273L212.492 77.8612Z"
              fill="#F8D1E6"
            />
            <mask
              id="mask8_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="137"
              y="-1"
              width="96"
              height="101"
            >
              <path d="M232.107 -0.00195312H137.834V99.2373H232.107V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask8_58571_32854)">
              <path
                d="M231.115 144.576C231.115 144.576 237.795 121.379 235.325 107.491C233.736 98.5621 219.617 104.74 219.617 104.74L221.399 143.926L231.115 144.576Z"
                fill="#F0E5D9"
              />
            </g>
            <path
              d="M153.234 96.8184L153.456 98.8865H200.215L188.21 96.8184H153.234Z"
              fill="#152435"
            />
            <path
              d="M144.547 73.2578L153.279 98.9436H182.726L173.994 73.2578H144.547Z"
              fill="#1C3047"
            />
            <path d="M153.234 98.8672L153.275 99.2399H200.215V98.8672H153.234Z" fill="#313D42" />
            <mask
              id="mask9_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="137"
              y="-1"
              width="96"
              height="101"
            >
              <path d="M232.107 -0.00195312H137.834V99.2373H232.107V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask9_58571_32854)">
              <path
                d="M163.706 86.5136C163.966 87.3938 163.581 88.2835 162.845 88.5C162.109 88.7164 161.304 88.1801 161.044 87.3C160.784 86.4198 161.169 85.53 161.905 85.3136C162.641 85.0972 163.446 85.6334 163.706 86.5136Z"
                fill="#280071"
              />
            </g>
            <mask
              id="mask10_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask10_58571_32854)">
              <path
                d="M207.387 81.4095C203.749 81.4095 200.788 84.3698 200.788 88.0107C200.788 91.6516 203.749 94.6095 207.387 94.6095C211.026 94.6095 213.986 91.6492 213.986 88.0107C213.986 84.3722 211.026 81.4095 207.387 81.4095ZM207.387 95.5498C203.229 95.5498 199.846 92.1662 199.846 88.0083C199.846 83.8504 203.227 80.4668 207.387 80.4668C211.548 80.4668 214.929 83.8504 214.929 88.0083C214.929 92.1662 211.545 95.5498 207.387 95.5498Z"
                fill="white"
              />
              <path
                d="M225.858 81.4095C222.219 81.4095 219.259 84.3698 219.259 88.0107C219.259 91.6516 222.219 94.6095 225.858 94.6095C229.496 94.6095 232.457 91.6492 232.457 88.0107C232.457 84.3722 229.496 81.4095 225.858 81.4095ZM225.858 95.5498C221.7 95.5498 218.316 92.1662 218.316 88.0083C218.316 83.8504 221.698 80.4668 225.858 80.4668C230.018 80.4668 233.399 83.8504 233.399 88.0083C233.399 92.1662 230.016 95.5498 225.858 95.5498Z"
                fill="#280071"
              />
            </g>
            <path d="M209.385 85.416H203.625V90.6032H209.385V85.416Z" fill="white" />
            <path d="M211.46 90.351L209.387 88.6436V87.3691L211.46 85.6641V90.351Z" fill="white" />
            <mask
              id="mask11_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask11_58571_32854)">
              <path
                d="M227.289 87.4877C227.289 88.2788 226.65 88.9185 225.859 88.9185C225.067 88.9185 224.428 88.2788 224.428 87.4877V84.4504C224.428 83.6592 225.067 83.0195 225.859 83.0195C226.65 83.0195 227.289 83.6592 227.289 84.4504V87.4877Z"
                fill="#280071"
              />
              <path
                d="M225.858 90.6389C224.15 90.6389 222.758 89.2489 222.758 87.5391H223.703C223.703 88.7294 224.67 89.6962 225.858 89.6962C227.046 89.6962 228.015 88.7294 228.015 87.5391H228.957C228.957 89.2465 227.567 90.6389 225.858 90.6389Z"
                fill="#280071"
              />
            </g>
            <path d="M226.329 90.168H225.387V92.9984H226.329V90.168Z" fill="#280071" />
            <path d="M49.25 29.0858V15.5371L60.6656 22.3115L49.25 29.0858Z" fill="#7E66AA" />
            <mask
              id="mask12_58571_32854"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="-1"
              width="240"
              height="183"
            >
              <path d="M240 -0.00195312H0V181.371H240V-0.00195312Z" fill="white" />
            </mask>
            <g mask="url(#mask12_58571_32854)">
              <path
                d="M171.748 138.258C171.748 139.619 170.644 140.725 169.28 140.725C167.917 140.725 166.813 139.619 166.813 138.258C166.813 136.897 167.919 135.791 169.28 135.791C170.642 135.791 171.748 136.897 171.748 138.258ZM176.271 139.08V137.435C176.271 136.981 175.903 136.613 175.449 136.613H174.797C174.694 136.267 174.557 135.932 174.393 135.615L174.749 135.259C174.934 135.074 175.04 134.821 175.04 134.557C175.04 134.292 174.934 134.042 174.749 133.855L173.686 132.792C173.501 132.607 173.248 132.501 172.984 132.501C172.719 132.501 172.469 132.607 172.282 132.792L171.926 133.148C171.611 132.982 171.276 132.847 170.928 132.744V132.092C170.928 131.637 170.56 131.27 170.105 131.27H168.46C168.008 131.27 167.638 131.637 167.638 132.092V132.744C167.292 132.847 166.957 132.984 166.64 133.148L166.284 132.792C166.099 132.607 165.846 132.501 165.582 132.501C165.317 132.501 165.067 132.607 164.882 132.792L163.819 133.855C163.634 134.042 163.528 134.295 163.528 134.557C163.528 134.819 163.634 135.074 163.819 135.259L164.175 135.615C164.012 135.93 163.874 136.267 163.771 136.613H163.119C162.665 136.613 162.297 136.981 162.297 137.435V139.08C162.297 139.535 162.665 139.903 163.119 139.903H163.771C163.877 140.249 164.014 140.583 164.175 140.901L163.819 141.257C163.634 141.442 163.528 141.697 163.528 141.959C163.528 142.221 163.634 142.474 163.819 142.661L164.882 143.724C165.067 143.909 165.32 144.015 165.582 144.015C165.844 144.015 166.099 143.909 166.284 143.724L166.64 143.368C166.957 143.534 167.292 143.669 167.638 143.772V144.424C167.638 144.878 168.008 145.246 168.46 145.246H170.105C170.56 145.246 170.928 144.878 170.928 144.424V143.772C171.276 143.669 171.608 143.532 171.926 143.368L172.282 143.724C172.469 143.909 172.722 144.015 172.984 144.015C173.246 144.015 173.501 143.909 173.686 143.724L174.749 142.661C174.934 142.474 175.04 142.221 175.04 141.959C175.04 141.697 174.934 141.442 174.749 141.257L174.393 140.901C174.559 140.586 174.694 140.249 174.797 139.903H175.449C175.903 139.903 176.271 139.535 176.271 139.08Z"
                fill="#7E66AA"
              />
            </g>
          </g>
        </svg>
      </div>

      <div className={styles['thank-you__content']}>
        <h3 className={styles['thank-you__heading']}>
          {formContent?.successTitle || 'Thank you!'}
        </h3>
        <p className={styles['thank-you__message']}>
          {formContent?.successDescription ||
            'Your message has been received. One of our team members will be in touch with you shortly!'}
        </p>
      </div>

      {formContent?.successCTA ? (
        <a
          href={formContent.successCTA.url}
          className={styles['thank-you__button']}
          aria-label={formContent.successCTA.label}
        >
          <span>{formContent.successCTA.label}</span>
          <ArrowRight className={styles['thank-you__button-icon']} size={20} />
        </a>
      ) : (
        <button
          type="button"
          onClick={onGoBack}
          className={styles['thank-you__button']}
          aria-label="Go back to form"
        >
          <span>Go back</span>
          <ArrowRight className={styles['thank-you__button-icon']} size={20} />
        </button>
      )}
    </div>
  );
};
